// src/core/api/axiosClient.js
import axios from "axios";
import { tokenStorage } from "../storage/tokenStorage";

// ✅ Base URL (Production + Local)
// Local:   REACT_APP_API_URL=http://localhost:8000
// Prod:    REACT_APP_API_URL=https://api.mockingjay.tech
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const axiosClient = axios.create({
  // ✅ Backend already has /api/... so keep base as domain only
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach Authorization header automatically
axiosClient.interceptors.request.use(
  (config) => {
    const token = tokenStorage.getAccess();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 globally
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      tokenStorage.clear();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?reason=expired";
      }
    }

    return Promise.reject(error);
  }
);
